import domain from './domain';

export const setTaskMessageTemplateCategoryId = domain.createEvent<ID | null>('setTaskMessageTemplateCategoryId');

export const resetTaskMessageTemplateCategories = domain.createEvent('resetTaskMessageTemplateCategories');
export const resetSelectedTaskMessageTemplateCategoryId = domain.createEvent(
    'resetSelectedTaskMessageTemplateCategoryId'
);
export const resetTaskMessageTemplates = domain.createEvent('resetTaskMessageTemplates');
